import React, { useState } from 'react';
import { ConfirmCompleteCoursesDialogComponent } from './confirm-complete-courses-dialog-component';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';

export interface IConfirmCompleteCoursesDialogProps {
  courseIds: string[];
}

export function ConfirmCompleteCoursesDialog({ courseIds }: IConfirmCompleteCoursesDialogProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  async function handleConfirm() {
    try {
      await moduleClientFactory.createAttendanceClient().updateCoursesStatus({
        courseIds,
        isCompleted: true,
      });
    } finally {
      setIsOpen(false);
    }
  }

  function handleClose() {
    setIsOpen(false);
  }

  return <ConfirmCompleteCoursesDialogComponent open={isOpen} coursesCount={courseIds.length} onCancelClick={handleClose} onConfirmClick={handleConfirm} />;
}
